/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatRupiah, formatDate, cleanText } from '../../../utils/helper';
import { Rating as RatingPackage } from 'react-simple-star-rating';
import { BottomSheet } from 'react-spring-bottom-sheet';

import { ReactComponent as StarFull } from '../../../common/images/star.svg';
import { useLocation } from 'react-router-dom';
import { VOUCHER_STATUS_NAME } from '../../../utils/constants';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { ChairIcon, TicketIcon, UltraVoucherIcon } from '../../../utils/svg';
import Rating from '../../Rating';
import { OrderStatusList } from '../../../utils/constants';
import ImageLoader from '../../ImageLoader/index';
import useNavigation from '../../../hook/useNavigation';

function OrderItem({ item = {}, orderType = 'all', ratingChanged = null, orderAgain = null, handlePopup = () => {} }) {
	const navigate = useNavigation();
	const location = useLocation();
	const currentPath = location.pathname;

	const [open, setOpen] = useState(false);

	const tab = useSelector((state) => state.order?.tab);
	const user = useSelector((store) => store?.user);
	const itemOrderType = cleanText(item?.orderType);
  	const tableNumber = item?.order_table_number || '-';

	const orderClass = (tab, status) => {
		switch (tab) {
			case 'pesanan':
				switch (status) {
					case '1':
					case '2':
					case '3':
						return 'on-process-list';
					case '4':
						return 'cmpleted-list';
					case '5':
						return 'canceled-list';
					default:
						return 'waiting-payment-list';
				}

			case 'topup':
				switch (status) {
					case '0':
						return 'waiting-payment-list';
					case '1':
						return 'cmpleted-list';
					case '2':
						return 'canceled-list';
					default:
						return 'on-process-list';
				}

			default:
				return 'default-list';
		};
  };

	const statusDetails = OrderStatusList?.[item?.orderStatus] ?? {};
	const trackingUrl =
		item?.delivery_order_details?.trackingUrl != null &&
		item?.delivery_order_details?.trackingUrl !== ''
			? item?.delivery_order_details?.trackingUrl
			: item?.delivery_tracking_url ?? '';
	
	return (
		<div className={orderClass(tab, item?.orderStatus || item?.topup_status)}>
			<ul>
				<li>
					<div className='flex p-4 w-full border-solid border-b-8 border-gray-100 flex-col'>
						<div className='flex'>
							<div className='rounded-xl w-28 h-fit aspect-square'>
								{tab === 'pesanan' ? <ImageLoader src={item?.store?.[0]?.image} alt={item?.store?.[0]?.name} /> : <UltraVoucherIcon className='h-full w-full rounded-xl object-cover object-center' />}
							</div>
							<div className='pl-3 w-full'>
								<Link to={tab === 'pesanan' ? `/history/${orderType}/${item?.orderNumber}` : `/history/${orderType}/${item?.topup_id}`} id='order_history_view_detail'>
									<p className='text-xs text-gray-800 font-normal'>Order ID {item?.orderNumber || item?.topup_order_number}</p>
									<h2 className='text-base font-semibold pt-1'>{tab === 'pesanan' ? item?.store?.[0]?.name : 'Top Up Ultra Value'}</h2>
									<div className='flex gap-1 items-center my-1 w-full flex-row'>
										<p className='text-xs text-gray-500 font-normal'>{formatDate(item?.order_date || item?.created_at, 'DD MMM y, HH:mm')}</p>
										<div className='menu-small text-center xs:text-left'>
											<strong className='!rounded-3xl'>{statusDetails?.message || item?.status_name || VOUCHER_STATUS_NAME[item?.topup_status]}</strong>
										</div>
									</div>
									<p className="text-xs text-black flex items-center gap-1">
										{(itemOrderType === 'pickup' && user?.is_b2b) ? (
										<>
											{TicketIcon({ className: "w-4 h-4" })}
											<span className='font-bold'>No. Antrian: {tableNumber}</span>
										</>
										) : (itemOrderType === 'dinein' && user?.is_b2b) ? (
										<>
											{ChairIcon({ className: "w-4 h-4" })}
											<span className='font-bold'>No. Meja: {tableNumber}</span>
										</>
										) : (
										<span>{`${item?.totalItem || item?.qty || 0} Items`}</span>
										)}
									</p>
								</Link>
								<div className='price-and-action border-gray-400 mt-4 pt-4'>
									<div>
										<h3 className='text-sm font-semibold'>{formatRupiah(item?.totalAmount || item?.total || 0)}</h3>
										<p className='text-xs text-gray-500 font-normal'>{item?.totalItem || item?.qty || 0} item</p>
									</div>
									{tab === 'pesanan' && (item?.orderStatus === '4' || item?.orderStatus === '5') && (
										<button onClick={() => orderAgain(item)} className='hidden button border-[var(--rose-violet)] !text-[var(--rose-violet)]' id='order_history_reorder'>
											Pesan Lagi
										</button>
									)}
								</div>
							</div>
						</div>
						{tab === 'pesanan' && item?.orderStatus === '4' && (
							<div
								className='w-full mt-4 cursor-pointer'
								style={{ border: '1px solid #D3D3D3', borderRadius: '6px' }}
								onClick={() => {
									if (!!parseFloat(item?.rating)) return;
									setOpen(true);
								}}>
								<div className='flex justify-between items-center m-3'>
									<p className='text-sm text-gray-800 font-semibold'>Beri penilaian pada makanan Anda</p>
									<RatingPackage initialValue={parseFloat(item?.rating || 0)} readonly allowFraction emptyIcon={<StarFull style={{ display: 'inline' }} />} fillIcon={<StarFull style={{ display: 'inline' }} />} />
								</div>
							</div>
						)}
					</div>
				</li>
			</ul>
			<BottomSheet onDismiss={() => setOpen(false)} open={open} snapPoints={({ minHeight }) => minHeight}>
				<Rating order={item} callback={() => setOpen(false)} />
			</BottomSheet>
		</div>
	);
}

export default OrderItem;
